const hero = document.querySelector('.simpleslider');

const observer = new IntersectionObserver((entries) => {
  if (entries[0].isIntersecting) {
    const slider = document.querySelector(".simpleslider");
    const slides = slider.querySelectorAll(".js-simpleslider-item");
    const prevBtn = slider.querySelector(".js-simpleslider-navigation-prev");
    const nextBtn = slider.querySelector(".js-simpleslider-navigation-next");
    const playBtn = slider.querySelector(".js-simpleslider-play");
    const pauseBtn = slider.querySelector(".js-simpleslider-pause");
    const dotsContainer = slider.querySelector(".js-simpleslider-dots");
    const ctaBtn = slider.querySelector(".js-simpleslider-cta");
    const interval = 6000;
    let current = 0;
    let timer;
    let keyListenerAdded = false;

    // Create dots
    slides.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.setAttribute("data-index", i);
      dot.setAttribute("aria-label", "Slider " + i);
      if (i === 0) dot.classList.add("active");
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll("button");

    function showSlide(index) {
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle("active", isActive);

        // Find the CTA button inside the slide
        const ctaButton = slide.querySelector('.js-simpleslider-cta');
        if (ctaButton) {
          if (isActive) {
            ctaButton.removeAttribute('tabindex');
          } else {
            ctaButton.setAttribute('tabindex', '1');
          }
        }
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });

      current = index;
    }

    function nextSlide() {
      const next = (current + 1) % slides.length;
      showSlide(next);
    }

    function prevSlide() {
      const prev = (current - 1 + slides.length) % slides.length;
      showSlide(prev);
    }

    function startAutoSlide() {
      timer = setInterval(nextSlide, interval);
    }

    function stopAutoSlide() {
      clearInterval(timer);
    }

    // Pause on hover
    // slider.addEventListener("mouseenter", stopAutoSlide);
    // slider.addEventListener("mouseleave", startAutoSlide);

    nextBtn.addEventListener("click", () => {
      stopAutoSlide();
      nextSlide();
      startAutoSlide();
    });

    prevBtn.addEventListener("click", () => {
      stopAutoSlide();
      prevSlide();
      startAutoSlide();
    });

    playBtn.addEventListener("click", () => {
      startAutoSlide();
      playBtn.style.display = "none";
      pauseBtn.style.display = "block";
    });

    pauseBtn.addEventListener("click", () => {
      stopAutoSlide();
      pauseBtn.style.display = "none";
      playBtn.style.display = "block";
    });

    dots.forEach(dot => {
      dot.addEventListener("click", (e) => {
        stopAutoSlide();
        showSlide(parseInt(e.target.dataset.index));
        startAutoSlide();
      });
    });

    // arrow left/right for prev/next
    window.addEventListener('scroll', handler);
    window.addEventListener('resize', handler);

    function handler() {
      const rect = slider.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = rect.top + scrollTop;
      const elementHeight = rect.height;
      const top_of_element = elementTop;
      const bottom_of_element = top_of_element + elementHeight;
      const top_of_screen = scrollTop;
      const bottom_of_screen = top_of_screen + window.innerHeight;
      const isVisible = (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);
    
      if (isVisible && !keyListenerAdded) {
        window.addEventListener('keydown', handleArrowKeys);
        keyListenerAdded = true;
      } else if (!isVisible && keyListenerAdded) {
        window.removeEventListener('keydown', handleArrowKeys);
        keyListenerAdded = false;
      }
    }

    function handleArrowKeys(event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        prevSlide();
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        nextSlide();
      }
    }

    showSlide(current);
    startAutoSlide();
    handler();
    observer.disconnect();
  }
}, { threshold: 0.1 });

if (hero) observer.observe(hero);